import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  inputProduct: {
    cursor: 'pointer',
    color: 'transparent',
    textShadow: '0 0 0 #1b1b1b',
  },
  rootInput: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    border: '1px solid #ced4da',
    marginTop: '0.5rem',
    boxShadow: '0 0px 0px 0 rgba(0,0,0,0.07)',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    fontSize: 20,
  },
  button: {
    padding: 8,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));
